import "./travelTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress, // Import CircularProgress for loading indicator
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const TravelTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTravel, setSelectedTravel] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  // Fetch all Travels
  useEffect(() => {
    const fetchTravel = async () => {
      setLoading(true); // Set loading state to true before fetching
      try {
        const res = await axios.get(
          `${BASE_URL}/api/travel/findAllTravel/${userId}`,
        );
        setData(res.data);
      } catch (err) {
        console.error("Error fetching travels:", err);
      }
      setLoading(false); // Set loading state to false after data is fetched
    };
    fetchTravel();
  }, [userId, BASE_URL]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/travel/deleteTravel/${id}`,
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error("Error deleting travel:", err);
    }
  };

  const handleUpdate = (travelData) => {
    navigate("/travel/newTravel", { state: { travel: travelData } }); // Pass user data to Travel
  };

  const travelListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "travelName",
      headerName: "Name",
      width: 230,
      renderCell: (params) => {
        return (
          <div className="cellWithImg">
            <img
              className="cellImg"
              src={params.row.travelImages?.[0]?.url}
              alt="avatar"
            />
            {params.row.travelName}
          </div>
        );
      },
    },
    {
      field: "travelGuidePhone",
      headerName: "Guide Phone",
      width: 120,
    },
    {
      field: "travelPrice",
      headerName: "Expense",
      width: 100,
    },
    {
      field: "travelPerson",
      headerName: "Person",
      width: 100,
    },
    {
      field: "travelDuration",
      headerName: "Duration",
      width: 100,
    },
    {
      field: "travelAddress",
      headerName: "Address",
      width: 200,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <IconButton color="primary" aria-label="addButton">
              <Link to="/travel/newTravel">
                <Add />
              </Link>
            </IconButton>

            <IconButton
              onClick={() => handleUpdate(params.row)}
              color="primary"
              aria-label="update"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={() => {
                setSelectedTravel(params.row);
                setOpenDialog(true);
              }}
              color="error"
              aria-label="delete"
            >
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedTravel(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedTravel) {
      await handleDelete(selectedTravel._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Travel Routes
        </Typography>
        <Link to="/travel/newTravel">
          <Button variant="contained" color="primary">
            Add Travel Route
          </Button>
        </Link>
      </div>
      <Grid container justifyContent="center">
        {loading ? ( // Show loading indicator while fetching
          <CircularProgress size={50} />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={travelListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}
      </Grid>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this Trek Route?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TravelTable;
